import React from 'react'
import MessageUI from '../../widgets/output/MessageUI'
import './SLogin.css'

const GoogleLoginUI = ({context, messageList, onClick}) =>
  <button
    className="s_login g_login"
    onClick={onClick}
    type="button"
  >
    <em></em>
    <MessageUI messageList={messageList} messageKey='c_login_with_g' />
  </button>

export default GoogleLoginUI
